"use client";
import * as React from "react";
import { useNavigate } from "react-router";

function AboutSection() {
    const navigate = useNavigate();
    
  const handleContactClick = () => {
    // Contact functionality can be implemented here
    console.log("Contact button clicked");
    navigate("/contact");
  };

  return (
    <section className="mb-32 max-sm:mb-20">
      <h2 className="mb-8 text-6xl font-bold leading-tight text-teal-600 max-sm:text-4xl">
        Small Group. Big Ambition.
      </h2>
      <p className="mb-6 text-lg leading-relaxed text-gray-700 max-w-[650px] max-sm:text-base">
        We are a lean team of developers and entrepreneurs obsessed with
        operational efficiency.
      </p>
      <p className="mb-10 text-lg leading-relaxed text-gray-700 max-w-[650px] max-sm:text-base">
        By staying small and focused, we avoid the bloat of traditional tech
        corporations, allowing us to ship clean code and high-impact
        features faster. We don't just build software; we build the tools we
        wished we had when we started our own journeys.
      </p>
      <button
        onClick={handleContactClick}
        className="px-8 py-3.5 text-base font-semibold text-white bg-teal-600 rounded-lg cursor-pointer border-[nonepx] hover:bg-teal-700 transition-colors"
      >
        Contact Us
      </button>
    </section>
  );
}

export default AboutSection;
